var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwipegesture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(32.156863%,38.823529%,40.392157%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 259.497097 566.199184 L 267.497955 558.198326 L 259.497097 550.197468 ",
    transform: "matrix(0.655203,0,0,0.655203,-130.499885,-354.580972)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(32.156863%,38.823529%,40.392157%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 251.502201 558.198326 L 267.497955 558.198326 ",
    transform: "matrix(0.655203,0,0,0.655203,-130.499885,-354.580972)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(32.156863%,38.823529%,40.392157%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 211.497912 566.199184 L 203.497054 558.198326 L 211.497912 550.197468 ",
    transform: "matrix(0.655203,0,0,0.655203,-130.499885,-354.580972)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(32.156863%,38.823529%,40.392157%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 219.49877 558.198326 L 203.497054 558.198326 ",
    transform: "matrix(0.655203,0,0,0.655203,-130.499885,-354.580972)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(32.156863%,38.823529%,40.392157%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 56.327947 40.077245 L 56.327947 36.076816 C 56.327947 30.776694 48.32709 30.776694 48.32709 36.076816 L 48.32709 32.076387 C 48.32709 26.776266 40.326232 26.776266 40.326232 32.076387 L 40.326232 16.074671 C 40.326232 10.77455 32.325374 10.77455 32.325374 16.074671 C 32.325374 27.277064 32.325374 33.077984 32.325374 47.076505 C 28.623039 43.37417 25.022057 38.378106 21.522427 41.877736 C 19.92464 43.475523 19.92464 45.973555 21.522427 47.577304 L 32.826173 58.875087 C 33.726418 59.775333 34.823406 60.17478 36.027708 60.073427 C 37.226048 60.17478 59.124074 60.073427 60.322414 60.073427 C 62.522352 60.073427 64.322843 58.278898 64.322843 56.07896 C 64.322843 50.373431 64.322843 45.574108 64.322843 40.077245 C 64.322843 34.777123 56.327947 34.777123 56.327947 40.077245 Z M 56.327947 40.077245 ",
    transform: "matrix(0.655203,0,0,0.655203,0,3.241262)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwipegesture);
export default __webpack_public_path__ + "static/media/swipegesture.12fa5455.svg";
export { ForwardRef as ReactComponent };